

















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import { InstituteInfo } from "../../_models/instituteInfo";
import { UserInfo } from "../../_models/userInfo";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import * as temp from "../../_store/temp.module"

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class GestioneTirEstiviTutorForm extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private reportDataTableParams: any;
  private createDialogParams: object;
  private createReportDialogParams: object;

  private listaAssegnazioni: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Tirocini Estivi",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
          text: "Azienda Ospitante",
          value: "denominazioneAzienda"
        },
        {
          text: "Data Inizio",
          value: "dataInizioPeriodo"
        },
        {
          text: "Data Fine",
          value: "dataFinePeriodo"
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          sortable: false
        },
        {
          text: "Dettagli Tirocinio",
          value: "dettagliTirEstivo",
          sortable: false
        },
        {
          text: "Report Visite",
          value: "reportVisite",
          sortable: false
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      filterType: "listaAbbinamenti",
      tirEstivoDialogParams: {
        title: "DETTAGLI TIROCINIO ESTIVO",
        type: "tirEstivoTab"
      },
      type: "tirocinioEstivo"
    };
    this.reportDataTableParams = {
      headers: [
        {
          text: "Data Visita",
          value: "dataVisita"
        },
        {
          text: "Ora Visita",
          value: "oraVisita"
        },
        {
          text: "Dettagli Report",
          value: "dettagliReportTirEstivo"
        },
        {
          text: "Confermato",
          value: "statusReport"
        }
      ],
      records: [],
      compileDialogParams: {
        title: "REPORT VISITA",
        type: "reportVisita"
      },
      detailsDialogParams: {
        title: "DETTAGLI REPORT VISITA",
        type: "reportVisita"
      },
      activityType: "tirocinioEstivo"
    };
    this.createReportDialogParams = {
      visible: true,
      type: "nuovoReportVisita"
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaAssegnazioni = [];
  }

  loadAssegnazioni(idAnnoScolastico: number) {
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    var payload = {
      idTutorForm: userInfo.idUtente,
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchAssociazioniTutorFormativoTirEstivi(this["$store"], payload)
      .then(result => {
        this.listaAssegnazioni = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            this.loadAssegnazioni(idAnnoScolastico);
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

      bus.$on("changeAnnoScolastico", (payload:any) =>{
        this.loadAssegnazioni(payload)
      })
  }
}
